import React, { useState, useEffect } from "react";

import Preloader from "./Preloader";
import IntroSection from "./IntroSection";
import MedalTallySection from "./MedalTallySection";
import MedalTallyGraphSection from "./MedalTallyGraphSection";
import DetailSection from "./DetailSection";
import FlashUpdatesSection from "./FlashUpdatesSection";
import ThisMonthEventsSection from "./ThisMonthEventsSection";
import ProgramSection from "./ProgramSection";
import GallerySection from "./GallerySection";
import RegisterSection from "./RegisterSection";
import { useLocation } from "react-router-dom";

const NAVBAR_HEIGHT = 80;

function scrollToAnchorWhenReady(anchor, maxWait = 1500) {
  const start = Date.now();
  function tryScroll() {
    const el = document.querySelector(anchor);
    if (el) {
      const y = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: y - NAVBAR_HEIGHT + 2, behavior: "smooth" });
      window.history.replaceState({}, document.title); // Clear anchor
    } else if (Date.now() - start < maxWait) {
      setTimeout(tryScroll, 60);
    }
  }
  tryScroll();
}

export default function HomePage() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // Simulate loading (replace with real async logic if needed)
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Only scroll after loading and if anchor exists in location.state
    if (!loading && location.state && location.state.anchor) {
      scrollToAnchorWhenReady(location.state.anchor);
    }
    // eslint-disable-next-line
  }, [loading, location.state]);

  if (loading) return <Preloader />;

  return (
    <>
      <IntroSection />
      <MedalTallySection />
      {/* <MedalTallyGraphSection /> */}
      <DetailSection />
      <FlashUpdatesSection />
      <ProgramSection />
      <ThisMonthEventsSection />
      <GallerySection />
      <RegisterSection />
      {/* ContactSection and Footer in MasterLayout.js */}
    </>
  );
}
